import {Coordinates} from '@/common/interfaces/geolocation';
import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {getGeolocation} from '@/common/helpers/geolocation/geolocationHelper';

export const determinateCoordinates = createAsyncThunk<PositionOptions | void, Coordinates, void>(
	'geolocation/determinateCoordinates',
	async (options, {success, failure}) => {
		const coordinates = await getGeolocation(options || undefined);
		return coordinates ? success(coordinates) : failure();
	},
);
